<template>
  <modal :title="title" :visible.sync="isShowDialog" width="1000px">
    <div class="uk-flex" v-if="mode === 'view'">
      <!-- 左侧树形 -->
      <div class="treeClass">
        <!-- <trees :treedata="dataTree" ref="tree" ></trees> -->

        <StatisticObject
          v-if="treeData.length"
          :tree-data="treeData"
          hide-button
          class="ex-tree"
          :key="1"
          :checked="dioForm.carrierList.map(_ => _.carrierId).join(',')"


        ></StatisticObject>
      </div>
      <el-form label-width="180px" label-position="right">
        <el-form-item :label="$t('public.taskName')">
          <span>{{ detailObj.taskName }}</span>
        </el-form-item>
        <el-form-item :label="$t('public.data')">
          <template v-if="detailObj.data">
            <el-tag v-if="detailObj.data.split('')[0] === '1'" class="mr-5">{{ $t('public.temp') }}</el-tag>
            <el-tag v-if="detailObj.data.split('')[1] === '1'" class="mr-5">{{ $t('public.hum') }}</el-tag>
            <el-tag v-if="detailObj.data.split('')[2] === '1'" class="mr-5">{{ $t('selectMsg.effective') }}{{ $t('public.exception') }}</el-tag>
            <el-tag v-if="detailObj.data.split('')[3] === '1'">{{ $t('public.All') }}{{ $t('public.exception') }}</el-tag>
            <el-tag v-if="detailObj.data.split('')[4] === '1'">{{ $t('gasType.0x00') }}</el-tag>
            <el-tag v-if="detailObj.data.split('')[5] === '1'">{{ $t('gasType.0x01') }}</el-tag>
            <el-tag v-if="detailObj.data.split('')[6] === '1'">{{ $t('gasType.0x04') }}</el-tag>
            <el-tag v-if="detailObj.data.split('')[7] === '1'">{{ $t('gasType.0x0A') }}</el-tag>
            <el-tag v-if="detailObj.data.split('')[8] === '1'">{{ $t('gasType.0x32') }}</el-tag>
            <el-tag v-if="detailObj.data.split('')[9] === '1'">{{ $t('equiType.magnetism') }}</el-tag>
          </template>
        </el-form-item>
        <el-form-item :label="$t('public.demonstrations')">
          <template v-if="detailObj.showType">
            <span v-if="detailObj.showType.split('')[0] === '1'">{{  $t('public.data') }}</span>
            <span v-if="detailObj.showType.split('')[0] === '1' && detailObj.showType.split('')[1] === '1'"> + </span>
            <span v-if="detailObj.showType.split('')[1] === '1'">{{  $t('integration.line_chart') }}</span>
          </template>
        </el-form-item>
        <!-- 数据时长 -->
        <el-form-item :label="$t('public.dataDuration')">
          <span>{{ detailObj.durationNum }}</span>
          <span>{{ detailObj.durationUnit === 1 ? $t('task.detection_interval_day') : $t('integration.month') }}</span>
        </el-form-item>
        <el-form-item :label="$t('public.file_from')">
          <p v-if="detailObj.genType === 1">{{ $t('integration.each_week')}}</p>
          <p v-else-if="detailObj.genType === 2">{{ $t('integration.each_month')}}</p>
          <p v-else>{{ $t('integration.each_year')}}</p>
          <p v-if="detailObj.time">
            <span v-if="detailObj.genType === 1">{{ weekArrConvert(detailObj.time.day) }}</span>
            <span v-else-if="detailObj.genType === 2">{{ dayArrConver(detailObj.time.day) }}</span>
            <span v-else>{{ monthArrConver(detailObj.time.month) }} {{ dayArrConver(detailObj.time.day) }}</span>
            <span class="ml-5">{{ detailObj.time.time }}</span>
          </p>
        </el-form-item>
        <!-- 文件类型 -->
        <el-form-item :label="$t('integration.file_type')">
          <span>{{  detailObj.fileType === 1 ? 'PDF' : 'Excel' }}</span>
        </el-form-item>

      </el-form>
    </div>
    <div v-else class="uk-flex">
      <div class="treeClass">
        <StatisticObject
          ref="tree"
          v-if="treeData.length"
          :loadNow="true"
          :tree-data="treeData"
          hide-button
          class="ex-tree"
          :key="2"
          :checked="dioForm.carrierList.map(_ => _.carrierId).join(',')"

        ></StatisticObject>
      </div>
      <el-form ref="form" :model="dioForm" label-width="180px" label-position="right">
        <!-- 右侧表单 -->
        <el-form-item prop="taskName" :label="$t('public.task_name')">
          <el-input v-model.trim="dioForm.taskName" style="width: 250px" maxlength="200"/>
        </el-form-item>
        <el-form-item  :label="$t('public.data')">
          <!-- <el-select v-model="dioForm.data" multiple >
            <el-option
              v-for="item in dataType"
              :key="item.value"
              :label="item.label"
              :value="parseInt(item.value)">
            </el-option>
          </el-select> -->

          <el-select v-model='data_web' multiple style='width: 250px'
                     :placeholder="$t('integration.please_select')">
            <el-option v-for='item in dataOptions' :key='item.value' :label='item.label' :value='item.value'
                       :disabled="item.disabled">
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item :label="$t('public.demonstrations')" prop='showType_web'>
          <el-select v-model='showType_web' style='width: 250px'
                     :placeholder="$t('integration.please_select')">
            <el-option v-for='item in fileArray' :key='item.code' :label='item.content' :value='item.code'>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 数据时长 -->
        <el-form-item :label="$t('public.dataDuration')" prop="durationNum">
          <el-input v-model.number="dioForm.durationNum" style="width:140px;"
                    oninput="value=value.replace(/[^\d.]/g, '')" />
          <el-select v-model="dioForm.durationUnit"
                     style="margin-left: 10px; width: 100px"
          >
            <el-option :label="item.label" :value="parseInt(item.value)" :key="key"
                       v-for="(item, key) in dateUnits"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('public.file_from')" prop="genType">
          <el-radio-group v-model="dioForm.genType">
            <el-radio :label="1">{{ $t('integration.each_week')}}</el-radio>
            <el-radio :label="2">{{ $t('integration.each_month')}}</el-radio>
            <el-radio :label="3">{{ $t('integration.each_year')}}</el-radio>
          </el-radio-group>
          <!-- 每周 -->
          <div class="uk-flex">

            <div v-if="dioForm.genType === 1">
              <el-select
                style="width:150px"
                v-model="dioForm.time.day"
              >
                <el-option
                  v-for="item in weekArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- 每月 -->
            <div v-else-if="dioForm.genType === 2">
              <el-select
                style="width:150px"
                v-model="dioForm.time.day"
              >
                <el-option
                  v-for="item in dayArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- 每年 -->
            <div v-else>
              <el-select
                style="width:100px"
                v-model="dioForm.time.month"
                @change="changeMonth"
              >
                <el-option
                  v-for="item in monthArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                style="width:100px"
                class="ml-5"
                v-model="dioForm.time.day"
              >
                <el-option
                  v-for="item in dayArr2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <el-time-picker
              v-model="dioForm.time.time"
              style="width: 100px;"
              class="ml-5"
              format="HH:mm"
              value-format="HH:mm"
            >
            </el-time-picker>
          </div>
        </el-form-item>
        <!-- 文件类型 -->
        <el-form-item :label="$t('integration.file_type')" prop="fileType">
          <el-select
            style="width:250px"
            v-model="dioForm.fileType"
          >
            <el-option
              v-for="item in fileTypeArray"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
    </div>
    <div slot="footer">
      <template v-if="mode === 'view'">
        <el-button v-if="detailObj.status === 0" type="primary" @click="changeModeEdit">{{ $t('integration.edit') }}</el-button>
        <el-button type="primary" @click="isShowDialog = false">{{ $t('buttonTitle.Return') }}</el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="mode='view'">{{ $t('public.btn_cancel') }}</el-button>
        <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
      </template>
    </div>
  </modal>
</template>
<script>
import { getExportTaskDetail, updateExportTask, addExportTask } from "@/api/modules/export"
import detailObj from '../../dataBoard/MonitoringPoint/win/mixin/detailObj'
import { dataType , dateUnits } from '@/utils/convert'
import { shareParam } from '@/api/modules/public.js'
import StatisticObject from '@/pages/count/statistic/component/StatisticObject/StatisticObject.vue'
import { shareTree } from '@/api/modules/public'


export default {
  components: {  StatisticObject },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    taskId: {
      type: String | Number,
      default: null
    }
  },
  data(){
    return {
      mode: 'view',
      detailObj: {},
      dioForm: {},
      // 因为参数格式和前端界面显示的格式不一样，增加一个字段方便写代码
      showType_web: '1',
      data_web: [],
      options: [],
      fileArray: [],
      fileTypeArray: [],
      dataType,
      dateUnits,

      treeData: [],

      dayArr2: []

    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    title() {
      return  this.mode === 'view' ? this.$t('integration.details') : this.$t('integration.edit')
    },
    dataTree() {
      return this.$store.getters.SchemaTree.filter(item => {
        return item.sceneCode !== 'all_node';
      });
    },
    // 数据下拉选择框
    dataOptions(){
      return [
        {
          value: 1,
          label: this.$t('public.temp')
        },
        {
          value: 2,
          label: this.$t('public.hum')
        },
        {
          value: 3,
          label: this.$t('public.effective_anomaly'),
          disabled: this.data_web.findIndex(_ => _ === 4) === -1 ? false : true
        },
        {
          value: 4,
          label: this.$t('public.all_anomaly'),
          disabled: this.data_web.findIndex(_ => _ === 3) === -1 ? false : true
        },
        {
          value: 5,
          label: this.$t('gasType.0x00')
        },
        {
          value: 6,
          label: this.$t('gasType.0x01')
        },
        {
          value: 7,
          label: this.$t('gasType.0x04')
        },
        {
          value: 8,
          label: this.$t('gasType.0x0A')
        },
        {
          value: 9,
          label: this.$t('gasType.0x32')
        },
        {
          value: 10,
          label: this.$t('equiType.magnetism')
        },
      ]
    },
    weekArr(){
      return [
        {
          value: 1,
          label: this.$t('week.Monday')
        },
        {
          value: 2,
          label: this.$t('week.Tuesday')
        },
        {
          value: 3,
          label: this.$t('week.Wednesday')
        },
        {
          value: 4,
          label: this.$t('week.Thursday')
        },
        {
          value: 5,
          label: this.$t('week.Friday')
        },
        {
          value: 6,
          label: this.$t('week.Saturday')
        },
        {
          value: 7,
          label: this.$t('week.Sunday')
        },
      ]
    },
    dayArr(){
      let arr = []
      for(let i=1; i<=31; i++){
        arr.push({
          value: i,
          label: i + this.$t('public.sun')
        })
      }
      arr.push({
        value: 0,
        label: this.$t('integration.last_day')
      })
      return arr
    },
    monthArr(){
      let arr = []
      for(let i=1; i<=12; i++){
        arr.push({
          value: i,
          label: i + this.$t('integration.month')
        })
      }
      return arr
    },
  },
  mounted(){
    this.getExDetail()
    this.getAlaTypes()
    this.getTree()
  },

  methods: {
    getExDetail(){
      getExportTaskDetail(this.taskId).then(res => {
        if (res.state.code === 200) {
          this.detailObj =  res.result
          this.dioForm = res.result
          // 整理showType_web和data_web
          let dataArr = this.dioForm.data.split('')
          dataArr.forEach((item, index) => {
            if(item === '1'){
              this.data_web.push(index + 1)
            }
          })
          if(this.dioForm.showType === '10'){
            this.showType_web = '0'
          }else if(this.dioForm.showType === '11'){
            this.showType_web = '1'
          }else{
            this.showType_web = '2'
          }
        }
      })
    },
    // 更新
    async handleSave(){
      let flag = await this.justify();
      if (!flag) return
      // 整理数据
      if(this.showType_web === '0'){
        this.dioForm.showType = '10'
      }else if(this.showType_web === '1'){
        this.dioForm.showType = '11'
      }else{
        this.dioForm.showType = '01'
      }

      let arr = ['0','0','0','0','0','0','0','0','0','0']
      this.data_web.forEach(item => {
        arr[item - 1] = '1'
      })
      this.dioForm.data = arr.join('')

      let ids =  this.$refs.tree.getTreeConfirm()
      console.log('ids=', ids)
      this.dioForm.carrierList = []
      ids.forEach(id => {
        this.dioForm.carrierList.push({
          carrierId: id
        })
      })

      updateExportTask({
        id: this.taskId,
        ...this.dioForm
      }).then(res => {
        if (res.state.code === 200) {
          this.$message.success($t('integration.success'))
          this.isShowDialog = false
          this.$parent.getList()
        }
      })
    },
    // 获取数据类型和展示方式
    getAlaTypes () {
      ['probe_data_type', 'export_file_type', 'export_type'].forEach(code => {
        shareParam({
          code,
          type: 0
        }).then(({ result }) => {
          if (code === 'probe_data_type') {
            this.options = result.filter(item => {
              if (item.content === 'temp' || item.content === 'hum') {
                return true
              } else {
                return false
              }
            })
            this.options = this.options.map(item => ({
              code: item.code,
              content: this.$t('sensor.' + item.content),
              name: item.content
            }))
          } else if(code === 'export_file_type'){
            this.fileArray = result.map(item => ({
              code: item.code,
              content: this.$t('analysis.' + item.content)
            }))
          }else{
            this.fileTypeArray = result.map(item => ({
              value: parseInt(item.code),
              label: item.name
            }))
          }
        })
      })
    },
    getTree () {
      shareTree({
        isEdit: 0,
        carrier: true,
        all: true
      }).then(({ result }) => {
        this.treeData = (result && result.item) || []
      })
    },
    async justify() {
      try {
        return await this.$refs['form'].validate()
      }
      catch (error) {
        return false
      }
    },
    resetForm(){
      this.dioForm = {
        taskName: null,
        data: null,
        showType: '11',
        fileType: null,
        durationNum: null,
        durationUnit: 2,
        genType: 1,
        time: {
          month: null,
          day: null, //日/周几
          time: "01:00" //时间
        },
        carrierList: []

      }
      this.showType_web = '1'
      this.data_web =  []
    },
    weekArrConvert(val){
      let index = this.weekArr.findIndex(_ => _.value === val)
      return this.weekArr[index].label
    },
    dayArrConver(val){
      let index = this.dayArr.findIndex(_ => _.value === val)
      return this.dayArr[index].label
    },
    monthArrConver(val){
      let index = this.monthArr.findIndex(_ => _.value === val)
      return this.monthArr[index].label
    },
    // 选择年后，后面的月份要跟着变化
    changeMonth(){
      this.dioForm.time.day = ''
      this.createDayArr2()
      let count = 31
    },
    // 切换编辑模式
    changeModeEdit(){
      this.mode='edit'
      this.createDayArr2()
    },
    createDayArr2(){
      let month = this.dioForm.time.month
      let count = 31
      switch(month){
        case 4:
        case 6:
        case 9:
        case 11:
          count = 30
          break
        case 2:
          count = 28
          break
      }
      let arr = []
      for(let i=1; i<=count; i++){
        arr.push({
          value: i,
          label: i + this.$t('public.sun')
        })
      }
      this.dayArr2 = arr
    }
  }
}
</script>
<style lang="scss" scoped>
.treeClass {
  width: 300px;
  height: 500px;
  overflow: auto;
  margin-right: 30px;

  .el-tree {
    height: 100%;
  }
}
.ex-tree {
  width: 300px;
  height: 400px;
  overflow: auto;
  ::v-deep .tree {
    height: 100%;
  }
}

</style>
